/** Deployment platform identifiers. */
export const Platform = {
  Web: "web",
  Agent: "agent",
} as const;

export type Platform = (typeof Platform)[keyof typeof Platform];
